export default "__VITE_ASSET__B$wg4IfP__"